import { useTheme } from "next-themes";
import type { ClienteFinalLogo } from "@/lib/Interfaces/user.interface";

type Logo = Partial<ClienteFinalLogo> | null | undefined;

const tieneLogo = (logo: Logo) => !!(logo && (logo.llave || logo.url));

/**
 * Devuelve el logo del cliente que corresponde al tema activo: el logo
 * inverso en modo obscuro (si existe) y el logo normal en los demás casos.
 * Devuelve null si el cliente no tiene logo.
 */
export function useLogoMarcaTema(cliente: {
  logoMarca?: Logo;
  logoMarcaInverso?: Logo;
} | null | undefined): Partial<ClienteFinalLogo> | null {
  const { resolvedTheme } = useTheme();
  if (resolvedTheme === "dark" && tieneLogo(cliente?.logoMarcaInverso)) {
    return cliente!.logoMarcaInverso!;
  }
  return tieneLogo(cliente?.logoMarca) ? cliente!.logoMarca! : null;
}
